import { ChangeDetectorRef, Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SquidexService } from '../../../../services/squidex.service';
import { Subscription } from 'rxjs'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { take } from 'rxjs/operators'

@Component({
  selector: 'flowaccount-e-tax-invoice-scoreboard',
  templateUrl: './e-tax-invoice-scoreboard.component.html',
  styleUrl: './e-tax-invoice-scoreboard.component.scss',
})
export class ETaxInvoiceScoreboardComponent {
  private subscriptionService: Subscription
  public serviceList: any
  private SCOREBOARD_ETAX_INVOICE_KEY = 'SCOREBOARD_ETAX_INVOICE_KEY'
  constructor(
    public translate: TranslateService,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
    public cdref: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // After scully builded
    if (isScullyGenerated()) {
      this.tstate
        .useScullyTransferState(this.SCOREBOARD_ETAX_INVOICE_KEY, this.serviceList)
        .subscribe((data: object[]) => {
          this.serviceList = data
        })
    } else {
      // run every build
      this.getTotalService()
    }
  }
  async getTotalService() {
    this.subscriptionService = await this.squidexService
      .getContentSquidexApi('scoreboard-etax-invoice')
      .pipe(take(1))
      .subscribe((data: object[]) => {
        this.serviceList = data
        this.tstate.setState(this.SCOREBOARD_ETAX_INVOICE_KEY, data)
        this.cdref.markForCheck()
      })
  }
  ngOnDestroy() {
    this.subscriptionService?.unsubscribe()
  }
}
